import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_143: FaireProductEntity = {
  token: "legacy_prod_abbott-143",
  type: "product",
  name: "Candy Cane Room Spray-100ml",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c695a0a09f812eaee5d590fdc16784a7d0061b6259c5b4c8863bdba9e14cff75.jpeg",
  priceDollars: 14,
  subcategory: "Room Sprays",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-fragrances"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
